import { HttpHelper } from "@/helper/HttpHelper";
import Cookies from 'js-cookie';

const getToken = () =>
    Cookies.get('token') ||
    (typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null);

// Server-safe fetch for category SEO metadata (no cookies required)
export const getCategoryMetadataAPI = async (categorySlug) => {
    try {
        const apiUrl =
            process.env.NEXT_PUBLIC_BASE_URL +
            '/category/' +
            categorySlug +
            '/content?type=&per_page=9&page=1';
        const response = await fetch(apiUrl, { next: { revalidate: 300 } });
        if (!response.ok) return null;
        const payload = await response.json();
        return payload?.data ?? null;
    } catch (error) {
        console.error('Error fetching category metadata:', error);
        return null;
    }
};

// Get Category List API
export const getCategoryListAPI = async (request) => {
    const { category, type, per_page, page } = request;
    const token = getToken();
    const headers = {
        'Authorization': `Bearer ${token}`,
    };
    const typeParam = encodeURIComponent(type ?? '');
    const perPage = per_page ?? 9;
    let apiUrl =
        process.env.NEXT_PUBLIC_BASE_URL +
        '/category/' +
        category +
        '/content?type=' +
        typeParam +
        '&per_page=' +
        perPage;
    if (page != null && page > 0) {
        apiUrl += '&page=' + page;
    }
    const response = await HttpHelper.get(apiUrl, { headers }).then((response) => response.data);
    return response;
}